import { ref } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

// Carga los partidos de AvanzaEsp para el picker de eventos.
// El endpoint devuelve un envelope propio de AvanzaEsp: { success, data, meta, error },
// donde la lista de partidos está en res.data.data (a diferencia de LFP no-sga,
// que devuelve el array directamente en res.data).
export function useEvoEvents() {
    const matches = ref([]);
    // loading arranca en true: la primera carga se dispara en onMounted del
    // picker, así el primer render ya muestra el skeleton y no el multiselect
    // vacío (evita el parpadeo).
    const loading = ref(true);
    const error = ref(false);

    async function loadMatches() {
        loading.value = true;
        error.value = false;

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.events.evo.index'),
                { filters: { page: 1, per_page: 100 } }
            );

            // Envelope válido SOLO si success es exactamente true y data es un
            // array. Cualquier otra forma (success ausente, null, no booleano,
            // false, data ausente o no-array) se trata como error recuperable:
            // no rompe el formulario.
            if (res.data && res.data.success === true && Array.isArray(res.data.data)) {
                matches.value = res.data.data;
            } else {
                matches.value = [];
                error.value = true;
            }
        } catch (err) {
            // 502 evo_upstream_error o 4xx de Evo: no romper el formulario,
            // dejar el picker vacío y ofrecer reintentar.
            console.error('Error al cargar los partidos de AvanzaEsp', err);
            matches.value = [];
            error.value = true;
        } finally {
            loading.value = false;
        }
    }

    return {
        matches,
        loading,
        error,
        loadMatches
    };
}
